import { BackToGame } from "components/molecules/BackToGame";
import { PageInfo, useBackToGame } from "hooks/useBackToGame";

const BackToGameContainer = () => {
  const { show, data, dismiss } = useBackToGame();
  return (
    <div>
      {show && data && (
        <BackToGame data={data as Required<PageInfo>} dismiss={dismiss} />
      )}
    </div>
  );
};

export default BackToGameContainer;
